<template>

<div>
  <nav class="navbar navbar-default navbar-fixed-top">
    <div id="redbar"></div>
    <div class="container">
      <div class="navbar-header">
        <button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#menu" aria-expanded="false">
	        <span class="sr-only">Toggle navigation</span>
	        <span class="icon-bar"></span>
	        <span class="icon-bar"></span>
	        <span class="icon-bar"></span>
	      </button>
        <a class="navbar-brand" href="#"><img src="~imgs/logo.png" alt=""></a>
      </div>
      <div id="menu" class="collapse navbar-collapse navbar-right">
        <ul class="nav navbar-nav navbar-right text-uppercase">
          <li v-for="(m, i) in menu" @click="changeActive(i)" :id="i"><a @click="smoothScroll($event)"  :href="'#' + m">{{m}}</a></li>
          
          <!--<li @click="changeLang()"><a href="#"><i class="fa fa-globe" aria-hidden="true"></i> {{idioma}} </a></li>-->
        </ul>
      </div>
    </div>
  </nav>
</div>

</template>

<script>
var $ = require('jquery')
export default{
  data(){
    return{
      menu:[
        'nosotros',
        'servicios',
        'flotilla',
        'clientes',
        'cobertura',
        'contacto'
      ],
      idioma: 'es',
    }
  },
  methods:{
    changeActive(id){
      $('#menu>ul>li').each((key, li) => {
        $('#' + key).removeClass('active')
      })
      $('#' + id).addClass('active')
    },
    smoothScroll(event){
      $('.navbar-toggle').click()
      var hash = event.path[0].hash
      $('html, body').animate({
        scrollTop: $(hash).offset().top
      }, 800, function(){
        window.location.hash = hash
      })
    }
  }
}

</script>

<style lang="scss" scoped>
@import '~varmix';

#redbar{
  background-color: $red;
  height: 20px;
}

nav{
  background-color: white;
  width: 100%;
  height: 125px;
  margin: 0;
  padding: 0;
  border: none;
  .navbar-collapse{
    background-color:white;
    text-align:right;
    @include celphone{
      margin-top: 50px;
    }
  }
  .navbar-nav{
    margin-top: 25px;
    li{
      a{
        &:hover{
          color: $red;
          
        }
        &:focus{
          color: $red;
        }

        @include dM{
          font-size: 13px;
        }
        @include tablet{
          font-size: 9px;
        }

        @include celphone{
          font-size: 18px;
          margin-bottom: 15px;
          padding: 0 20px;
        }
      }
    }
    .active{
      a{
        background-color: transparent;
        color: $red;
        &:hover, &:focus, &:active{
          color: $red;
          background-color: transparent;
        }
      }
    }
  }
  img{
    margin-top: 0;
  }
}

</style>



// WEBPACK FOOTER //
// Header.vue?77471311